import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import PracticeUsersSearchBar from "../../../containers/admin/asquera-practice/searchbar";
import PracticeUsersTable from "../../../containers/admin/asquera-practice/users-table";
import UserSubscriptionsModal from "../../../containers/admin/asquera-practice/user-subscriptions-modal";

const AsqueraPracticeUsers = () => {
  const users = useSelector((state) => state.asqueraPractice.users);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!selectedUser?.id || !Array.isArray(users)) return;
    const updated = users.find((user) => user.id === selectedUser.id);
    if (updated) {
      setSelectedUser(updated);
    }
  }, [users, selectedUser?.id]);

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  return (
    <Layout>
      <Box w="100%" p={4}>
        <PracticeUsersSearchBar setSearchTerm={setSearchTerm} />
        <PracticeUsersTable
          onUserClick={handleUserClick}
          searchTerm={searchTerm}
        />
        <UserSubscriptionsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          user={selectedUser}
          searchTerm={searchTerm}
        />
      </Box>
    </Layout>
  );
};

export default AsqueraPracticeUsers;
